import React from "react";
import "./ServicesSection.scss";
import {
  FaHandshake,
  FaBriefcase,
  FaCalculator,
  FaMobileAlt,
  FaLaptopCode,
  FaLayerGroup,
  FaPenNib,
  FaCode,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const ServicesSection = () => {
  const navigate = useNavigate();
  return (
    <div className="services-container"  id="services">
      {/* --- Main Header --- */}
      <div className="header-section">
        <div className="title-pill">OUR SERVICES</div>
        <p className="subtitle">We Are Offering All Kinds of IT Solutions Services</p>
      </div>

      {/* --- Diagram Wrapper --- */}
      <div className="diagram-wrapper">
        
        {/* CENTER PIECE (Handshake) */}
        <div className="center-node">
          <div className="icon-wrapper">
            <FaHandshake className="handshake-icon" />
          </div>
        </div>

        {/* --- CONNECTORS (Lines) --- */}
        {/* These lines sit behind the cards and connect to the center */}
        <div className="connector line-yellow"></div>
        <div className="connector line-cyan"></div>
        <div className="connector line-blue-stem"></div>
        <div className="connector line-blue-arm"></div>
        <div className="connector line-orange-stem"></div>
        <div className="connector line-orange-arm"></div>
        <div className="connector line-pink"></div>

        {/* --- CARDS --- */}

        {/* Top Left: Yellow */}
        <div className="service-card card-yellow" onClick={ () => navigate("/app-development")}>
          <div className="card-icon-circle">
           <FaMobileAlt/>
            
          </div>
          <div className="card-content">
            <h3>App Development</h3>
            <p>
            We specialize in developing feature-rich mobile applications for iOS, Android, and cross-platform environments to help businesses connect with their customers on the go
            </p>
          </div>
        </div>

        {/* Top Right: Cyan */}
        <div className="service-card card-cyan" onClick={ () => navigate("/web-development")}>
          <div className="card-icon-circle">
            <FaLaptopCode />
          </div>
          <div className="card-content">
            <h3>Web Development</h3>
            <p>
             We provide top-quality website development services for startups, enterprises & entrepreneurs.
            </p>
          </div>
        </div>

        {/* Middle Left: Blue */}
        <div className="service-card card-blue" onClick={ () => navigate("/uiux-development")}>
          <div className="card-icon-circle">
            <FaPenNib />
          </div>
          <div className="card-content">
            <h3>UI/UX Design</h3>
            <p>
             Our design team focuses on creating intuitive, aesthetically pleasing, and user-centric interfaces to deliver an exceptional user experience.
            </p>
          </div>
        </div>

        {/* Middle Right: Orange */}
        <div className="service-card card-orange" onClick={ () => navigate("/software-development")}>
          <div className="card-icon-circle">
            <FaCode />
          </div>
          <div className="card-content">
            <h3>Software Development</h3>
            <p>
             Econsign Soft has proven expertise in building reliable and scalable software solutions that bring new value to your business.
            </p>
          </div>
        </div>

        {/* Bottom: Pink */}
        <div className="service-card card-pink"  onClick={ () => navigate("/fullstack-development")}>
          <div className="card-icon-circle">
            <FaLayerGroup />
          </div>
          <div className="card-content">
            <h3>Full Stack Development</h3>
            <p>
             We provide comprehensive full-stack development services, encompassing both front-end and back-end technologies, to deliver seamless and efficient applications.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesSection;